import * as React from "react";
import { isReportBackendWidget } from "report/typeGuards/reportingWidget";
import PrintWidget from "common/components/widgetRenderers/PrintWidget";
import { reportWidgetHeaderId } from "report/Constants";
const ReportingWidget = ({
  description = void 0,
  height = void 0,
  hideDescription,
  hideQuery,
  interactive = true,
  limitHeight = false,
  showCaption = true,
  showHandle = true,
  showHeading = true,
  title = void 0,
  value,
  widget,
  width = void 0
}) => {
  const isBackendWidget = isReportBackendWidget(widget);
  const widgetId = isBackendWidget ? widget.dashboard_widget_id : widget.id;
  const headerId = isBackendWidget ? reportWidgetHeaderId(widget.dashboard_id, widgetId) : void 0;
  const _hideDescription = hideDescription || !isBackendWidget;
  return /* @__PURE__ */ React.createElement(
    PrintWidget,
    {
      widget,
      widgetId,
      value,
      showCaption,
      showHeading,
      showHandle,
      height,
      headerId,
      width,
      interactive,
      limitHeight,
      hideDescription: _hideDescription,
      hideQuery,
      title,
      description
    }
  );
};
export default ReportingWidget;
